import { c as _c } from "react/compiler-runtime";
import { AutomationRuleErrorInterface, AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { useState } from 'react';
const defaultErrors: AutomationRuleErrorInterface = {
  automationTriggers: {},
  automationActions: {}
};
const defaultRule = {
  actions: [],
  triggers: [],
  active: true
};
export const useRuleState = () => {
  const $ = _c(4);
  const [tempState, setTempState] = useState(defaultRule);
  const [errors, setErrors] = useState(defaultErrors);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setTempState(defaultRule);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const clearState = t0;
  let t1;
  if ($[1] !== errors || $[2] !== tempState) {
    t1 = {
      tempState,
      setTempState,
      errors,
      setErrors,
      clearState
    };
    $[1] = errors;
    $[2] = tempState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};